/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'menu': {
    width: 124,
    height: 124,
    viewBox: '0 0 124 124',
    data: '<path pid="0" d="M112 6H12C5.4 6 0 11.4 0 18s5.4 12 12 12h100c6.6 0 12-5.4 12-12s-5.4-12-12-12zM112 50H12C5.4 50 0 55.4 0 62s5.4 12 12 12h100c6.6 0 12-5.4 12-12s-5.4-12-12-12zM112 94H12c-6.6 0-12 5.4-12 12s5.4 12 12 12h100c6.6 0 12-5.4 12-12s-5.4-12-12-12z"/>'
  }
})
